<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <Nav />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <div class="eol-main-container">
        <div class="origin-content">
          <div class="content-header">
            <div class="text">认识生命的起源</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item, index in originData" :key="index"
              :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <div class="precious-content">
          <div class="content-header">
            <div class="text">感悟生命的宝贵</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item, index in preciousData" :key="index"
              :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <div class="create-content">
          <div class="content-header">
            <div class="text">守护生命的健康</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item, index in healthData" :key="index"
              :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <!-- <div class="create-content">
          <div class="content-header">
            <div class="text">创造生命的精彩</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item,index in createData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div> -->

        <div class="rdbb-con">
          <div class="content-header">
            <div class="text">创造生命的精彩</div>
          </div>
          <div class="rdbb-info">
            <div class="info-lfet">
              <div class="swiper">
                <swiper :options="swiperOption" v-if="createData.length > 0" ref="rdbbSwiper">
                  <swiper-slide v-for="item in createData" :key="item.id" @click="jumpDetail(item)" :data-id="item.id">
                    <div class="cover" :style="`background-image: url(${item.photo});`" :data-id="item.id"></div>
                  </swiper-slide>

                </swiper>
                <div class="b swiper-button-next">
                </div>
                <div class="b swiper-button-prev">
                </div>
              </div>
              <div class="rdbb-page">
                <div class="page-item" @click="slideChange(i)" v-for="i in createData.length" :key="i"
                  :class="{ active: swiperActive == i - 1 }">{{ i }}</div>
              </div>

            </div>
            <div class="info-right">
              <div class="info-link" @click="jumpDetail(createData[swiperActive])" v-if="createData.length > 0">
                <div class="info-title">{{ createData[swiperActive]?.name }}</div>
                <div class="info-desc" v-html="decodeHtml(createData[swiperActive]?.intro)"></div>
              </div>

              <div class="info-list">
                <div class="info-item" :class="{ active: item.id == createData[swiperActive]?.id }"
                  v-for="(item, ind) in createData" :key="item.id" @click="slideChange(ind + 1)">
                  <div class="cover" :style="`background-image: url(${item.photo});`"></div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="accept-content">
          <div class="content-header">
            <div class="text">接纳生命的有限</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item, index in acceptData" :key="index"
              :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import utils from '../../../config/utils'
import ScreenAdapter from "@/components/ScreenAdapter.vue"


export default {
  data() {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/vita.jpg"),
      school_code: services.HZ_CODE,
      originData: [], // 认识生命的起源
      preciousData: [], // 感悟生命的宝贵
      healthData: [], // 守护生命的健康
      createData: [], // 创造生命的精彩
      acceptData: [], // 接纳生命的有限
      swiperActive: 0,
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next.b",
          prevEl: ".swiper-button-prev.b",
        },
        on: {
          slideChangeTransitionEnd() {
            that.swiperActive = this.realIndex
          },
          click() {
            const slide = this.clickedSlide
            if (!slide) return

            const id = slide.getAttribute("data-id")
            window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=vita`, "_blank")
          }
        }
      },
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  async mounted() {
    await this.getListData()
  },
  methods: {
    // 请求列表数据
    async getListData() {
      // 认识生命的起源
      await services.getCourseList({ page: 1, size: 2, category_id: "153", school_code: this.school_code }).then(res => {
        this.originData = res.data.items
      })

      // 感悟生命的宝贵
      await services.getCourseList({ page: 1, size: 3, category_id: "154", school_code: this.school_code }).then(res => {
        this.preciousData = res.data.items
      })

      // 守护生命的健康
      await services.getCourseList({ page: 1, size: 2, category_id: utils.hz_shsmdjkId, school_code: this.school_code }).then(res => {
        this.healthData = res.data.items
      })

      // 创造生命的精彩
      await services.getCourseList({ page: 1, size: 2, category_id: "155",is_intro: "1", school_code: this.school_code }).then(res => {
        this.createData = res.data.items
      })

      // 接纳生命的有限
      await services.getCourseList({ page: 1, size: 1, category_id: "156", school_code: this.school_code }).then(res => {
        this.acceptData = res.data.items
      })
    },
    jumpDetail(item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=vita`, "_blank")
    },
    decodeHtml(html) {
      if (!html) return '';
      // 方法1：使用 DOMParser
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.documentElement.textContent;
    },
    slideChange(index) {
      this.swiperActive = index - 1
      this.$refs.rdbbSwiper.swiper.slideToLoop(index - 1)
    }

    // 锚点定位
    // jumpPosition () {
    //   let that = this
    //   let position = that.$route.query.id
    //   if (position) {
    //     that.$nextTick(() => {
    //       let topVal = this.$refs[position].getBoundingClientRect().top
    //       let element = document.getElementsByClassName("outContainer")[0]
    //       element.scrollTop = topVal - 100
    //     })
    //   }
    // },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}

.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto 120px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    display: inline-block;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    width: 1920px;
    height: 1705px;
    background: url('../../../assets/hzvtc/list/vita-t-bg.png') no-repeat center/cover;
  }

  .content-header {
    width: 1400px;
    margin: 0 auto 30px;
    font-weight: bold;
    font-size: 42px;
    color: #B61E2A;
    background: linear-gradient(0deg, #B61E2A 0%, #EF350A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    position: relative;
    z-index: 2;

    &::after {
      width: 1400px;
      margin-top: 16px;
      height: 35px;
      content: "";
      display: block;
      background-image: url("../../../assets/hzvtc/list/hzdx-title.png");
      background-size: cover;
      background-position: center;
      // position: absolute;
    }
  }

  .content-box {
    position: relative;
    z-index: 2;
  }

  .rdbb-con {
    padding: 70px 0 0;
    .rdbb-info {
      height: 436px;
      margin-top: 30px;
      display: flex;

      .info-lfet {
        width: 776px;
        position: relative;

        .swiper {
          height: 436px;

          .swiper-container {
            height: 100%;

            .swiper-wrapper {
              .swiper-slide {
                // width: 100%;
                background-color: #B61E2A;
                overflow: hidden;
                height: 100%;
                cursor: pointer;

                &:hover {
                  .cover {
                    transform: scale(1.1);
                  }
                }

                .cover {
                  width: 100%;
                  height: 100%;
                  background-size: cover;
                  background-position: center;
                  transition: all 0.3s;
                }
              }
            }
          }

          .b.swiper-button-prev {
            width: 44px;
            height: 44px;
            background: linear-gradient(0deg, #B61E2A 0%, #DF424E 100%);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateX(-50%);
            z-index: 11;
            left: 0;
            cursor: pointer;

            &:hover {
              background: #B61E2A;
            }

            &::after {
              width: 11px;
              height: 24px;
              content: "";
              display: block;
              background-image: url("../../../assets/hzvtc/list/hzdx-prev.png");
              background-size: cover;
              background-position: center;
            }

          }

          .b.swiper-button-next {
            width: 44px;
            height: 44px;
            background: linear-gradient(0deg, #B61E2A 0%, #DF424E 100%);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateX(50%);
            z-index: 11;
            right: 0;
            cursor: pointer;

            &:hover {
              background: #B61E2A;
            }

            &::after {
              width: 11px;
              height: 24px;
              content: "";
              display: block;
              background-image: url("../../../assets/hzvtc/list/hzdx-prev.png");
              background-size: cover;
              background-position: center;
              transform: rotate(180deg);
            }

          }
        }

        .rdbb-page {
          position: absolute;
          bottom: 32px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          z-index: 11;

          .page-item {
            width: 32px;
            height: 32px;
            background: rgba(71, 8, 3, 0.5);
            border-radius: 2px;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 32px;
            width: 32px;
            text-align: center;
            margin: 0 6px;
            cursor: pointer;

            &.active {
              background: #b61e2a;


            }
          }
        }
      }

      .info-right {
        height: 436px;
        background: linear-gradient(0deg, #FFFFFF 0%, #FDFAFA 66%, #FFF1D5 100%);
        border-radius: 4px;
        flex: 1;
        padding: 40px 56px 0;

        .info-link {
          cursor: pointer;

        }

        .info-title {
          font-weight: bold;
          font-size: 24px;
          color: #31302F;

          .title-keywords {
            height: 32px;
            background: linear-gradient(90deg, #E7984C 0%, #F65C4B 100%);
            border-radius: 4px;
            display: inline-block;
            white-space: nowrap;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 32px;
            padding: 0 17px;
            margin-left: 23px;
          }
        }

        .info-desc {
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 32px;
          height: 128px;
          margin-top: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
        }

        .info-list {
          display: flex;
          justify-content: space-between;
          margin-top: 35px;

          .info-item {
            width: 240px;
            height: 135px;
            border-radius: 4px;
            position: relative;
            cursor: pointer;
            overflow: hidden;

            &.active {
              &::after {
                display: none;
              }
            }

            &::after {
              content: "";
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.4);
            }

            .cover {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center;
              transition: all 0.3s;
            }
          }
        }
      }
    }

  }

  .origin-content {
    .content-header {
      margin: 47px 0 40px;
    }

    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .item {
        width: 674px;
        height: 379px;
        cursor: pointer;
        margin-bottom: 24px;
      }
    }
  }

  .precious-content {
    .content-header {
      margin: 45px 0 30px;
    }

    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .item {
        width: 446px;
        height: 251px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }

  .create-content {
    .content-header {
      margin: 50px 0 40px;
    }

    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .item {
        margin-bottom: 24px;
        cursor: pointer;
        width: 674px;
        height: 379px;
      }
    }
  }

  .accept-content {
    position: relative;
    top: 35px;
    margin: 0 0 25px;

    &::before {
      content: '';
      width: 1920px;
      height: 960px;
      background: url('../../../assets/hzvtc/list/value-c-bg.png') no-repeat center/cover;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 110px;
    }

    .content-header {
      margin: 40px 0 0;
    }

    .content-box {
      width: 100%;
      height: 865px;
      background: url('../../../assets/hzvtc/list/vita-b-news.png') no-repeat center/cover;
      position: relative;
      margin-top: -24px;

      .item {
        cursor: pointer;
        width: 953px;
        height: 536px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

::v-deep .footer-container {
  margin-top: -80px;
}
</style>